module.exports = __webpack_public_path__ + "static/media/kz-consult-qrcode.9b7e6456.png";